import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

/**
 * Initializes the Mapbox map and geocoder.
 *
 * @param {object} mapContainerRef - The reference to the map container element.
 * @param {object} geocoderContainerRef - The reference to the geocoder container element.
 * @param {function} onLocationSelect - Callback function to handle location selection, receiving place name, latitude, and longitude.
 * @param {string} placeholder - Placeholder text for the search bar.
 * @param {object} options - Additional options (e.g., countries restriction).
 */
export const initializeMapbox = (
  mapContainerRef,
  geocoderContainerRef,
  onLocationSelect,
  placeholder = "Search for location...",
  options = {}
) => {
  if (
    mapContainerRef.current &&
    mapContainerRef.current.childNodes.length === 0
  ) {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-98.35, 39.5], // U.S. center
      zoom: 3,
    });

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: placeholder,
      marker: false,
      fuzzyMatch: true,
      countries: options.countries, // Prioritize U.S. searches but allow global
      proximity: { longitude: -97.0, latitude: 39.5 }, // Favor U.S. results
    });

    if (
      geocoderContainerRef.current &&
      geocoderContainerRef.current.childNodes.length === 0
    ) {
      geocoderContainerRef.current.appendChild(geocoder.onAdd(map));
      geocoder.on("result", (e) => {
        const { place_name, geometry } = e.result;
        const [lng, lat] = geometry.coordinates;
        onLocationSelect(place_name, lat, lng);
      });
    }

    return { map, geocoder };
  }

  return { map: null, geocoder: null };
};
